import ModalCompanyImageGallery from 'components/modal/ModalCompanyImageGallery';

import { useState, type JSX } from 'react';
import { Controller, useWatch } from 'react-hook-form';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { getContentImageUrl } from 'utils/app';

/**
 * クイズ作成編集 デザイン設定コンポーネント
 */
export default function FormCompanyImage<TFieldValues extends FieldValues = FieldValues>(props: {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  readOnly?: boolean;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [isImageModalOpenState, setIsImageModalOpenState] = useState(false);

  const value = useWatch({
    control: props.control,
    name: props.name,
  });
  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <Controller
        name={props.name}
        control={props.control}
        defaultValue={null}
        render={({ field }) => {
          return (
            <>
              {/* <img src={getContentImageUrl(value)} className="img-fluid featured" /> */}
              <img
                src={getContentImageUrl(typeof value === 'string' ? value : value?.imageKey || '')}
                className="img-fluid featured"
              />
              <div>
                {/* アップロードボタン */}
                <button
                  onClick={() => setIsImageModalOpenState(true)}
                  className="btn btn-default me-1"
                  disabled={props.readOnly}
                >
                  アップロード
                </button>
                {/* 削除ボタン */}
                <button
                  onClick={() => field.onChange(null)}
                  disabled={props.readOnly}
                  className="btn btn-empty"
                >
                  <img src="/img/icon/trash.svg" alt="" className="img-fluid" />
                </button>
              </div>
              {/* カンパニー画像選択モーダル */}
              <ModalCompanyImageGallery
                setOpen={setIsImageModalOpenState}
                open={isImageModalOpenState}
                onImageSelected={(value: string) => {
                  if (value) {
                    field.onChange(value);
                  }
                }}
              />
            </>
          );
        }}
      />
    </>
  );
}
